import restUrls from "web/constants/restUrls";

import { ICodeSettings, IProductCode } from "web/types/Code";

import api from "../api/apiSlice";
import { transformSplittedCode } from "./utils/helpers";

export interface IProductCodeLine {
  name: string;
  value: string;
}

export interface IProductCodeTransformed {
  isSplitted: boolean;
  code: string | string[] | IProductCodeLine[];
  isNewStructure: boolean;
}

const shouldUseNewStructure = (splittedCode: IProductCode["splittedCode"]) => {
  return (
    !!splittedCode &&
    (typeof splittedCode.pierwsza_linijka_pod_kodem_kreskowym !== "string" ||
      Array.isArray(splittedCode))
  );
};

export const codesApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getCodeSettings: builder.query<ICodeSettings, string>({
      query: (sku) => ({
        url: restUrls.codeSettings.replace("{sku}", sku),
      }),
      providesTags: ["CodeSettings"],
    }),

    getProductCode: builder.query<IProductCodeTransformed, string | number>({
      query: (itemId) => ({
        url: `${restUrls.productCode}?item_id=${itemId}`,
      }),
      providesTags: ["ProductCode"],
      transformResponse: (response: IProductCode[]) => {
        const splittedCode = response[0]?.splittedCode;

        const isNewStructure = shouldUseNewStructure(response[0]?.splittedCode);

        const splittedCodeTransformed = transformSplittedCode(splittedCode);
        return {
          code: splittedCodeTransformed ?? response[0]?.code,
          isSplitted: !!splittedCode,
          isNewStructure,
        };
      },
    }),

    getBarCode: builder.query<string, string | number>({
      query: (itemId) => ({
        url: `${restUrls.barCodeImage}?itemId=${itemId}`,
      }),
      providesTags: ["BarCode"],
      transformResponse: (response: string) =>
        `data:image/png;base64,${response}`,
    }),
  }),
});

export const {
  useGetCodeSettingsQuery,
  useGetProductCodeQuery,
  useGetBarCodeQuery,
} = codesApiSlice;
